import { render } from "./Communications.vue?vue&type=template&id=e0bf602c"
import script from "./Communications.vue?vue&type=script&lang=js"
export * from "./Communications.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__